import { combineReducers } from '@reduxjs/toolkit'


import dropZoneReducer from '../features/upload/dropZoneSlice'

import ovscReducer from '../features/signing/ovscSlice'
import authenticodeSlice from '../features/authenticode/authenticodeSlice'
const rootReducer = combineReducers({
  dropZone: dropZoneReducer,
  ovsc: ovscReducer,
  authenticode:authenticodeSlice
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
